import { render, staticRenderFns } from "./BigBrandBedsReports.vue?vue&type=template&id=0fc2254a&scoped=true"
import script from "./BigBrandBedsReports.vue?vue&type=script&setup=true&lang=js"
export * from "./BigBrandBedsReports.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BigBrandBedsReports.vue?vue&type=style&index=0&id=0fc2254a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc2254a",
  null
  
)

export default component.exports